import { colors, RadioGroup, typography } from '@insurancemenu/imenu-components-lib';
import { ListStyled } from '@insurancemenu/imenu-components-lib/dist/components/RadioGroup/styles';
import { RadioLabelWrapperStyled } from '@insurancemenu/imenu-components-lib/dist/components/RadioButton/styles';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const ContentHeaderStyled = styled.header`
  padding-bottom: 3rem;
  border-bottom: 1px solid ${colors.neutral[300]};

  ${breakpointsMQ4.sm.down} {
    padding-bottom: 2rem;
  }
`;

export const ContentTitleStyled = styled.h2`
  color: ${colors.neutral[900]};
  ${typography.bold[24]};
  margin: 0 0 1rem;

  ${breakpointsMQ4.sm.down} {
    ${typography.bold[20]};
  }
`;

export const ContentSubtitleStyled = styled.h3`
  color: ${colors.neutral[900]};
  ${typography.regular[16]};
  margin: 0;
`;

export const AnswersSectionWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5rem;
  padding-top: 3rem;
`;

export const RadioGroupStyled = styled(RadioGroup)`
  & ${ListStyled} {
    gap: 3rem;
    padding-bottom: 0;
  }

  & ${RadioLabelWrapperStyled} {
    gap: 2rem;
    align-items: center;
  }
`;
